<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import type {
        UserListEntry,
        UserResponse,
    } from "../../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../../GlobalHelper/ApiClient";
    import { user } from "../../../../../store/stores";
    import PermissionsTable from "./PermissionsTable.svelte";

    const navigate = useNavigate();
    export let userEntry: UserListEntry;

    $: if (userEntry) {
        openDropdown = false;
    }

    let openDropdown: boolean = false;

    let userDetails: UserResponse;

    const getUser = async () => {
        await ApiClient.getInstance($user)
            .userAuthorityClient.resolvePermissionsForCurrentUser({})
            .then(console.log);
        // await ApiClient.getInstance($user)
        //     .userClient.({ userId: userEntry.id })
        //     .then((user) => (userDetails = user));
    };
</script>

<div class="column is-12">
    <div class="columns is-vcentered">
        <div
            class="column is-3 username is-offset-2"
            on:click={() => navigate(userEntry.id)}
        >
            {userEntry.username}
        </div>
        <div class="column is-3">
            {userEntry.firstName}
        </div>
        <div class="column is-3">
            {userEntry.lastName}
        </div>
        <!-- <div class="column is-1">
                        {#if !openDropdown}
                            <span
                                class="icon"
                                on:click={() => {
                                    getUser();
                                    openDropdown = !openDropdown;
                                }}
                            >
                                <i class="fas fa-angle-down" />
                            </span>
                        {/if}

                        {#if openDropdown}
                            <span
                                class="icon"
                                on:click={() => {
                                    getUser();
                                    openDropdown = !openDropdown;
                                }}
                            >
                                <i class="fas fa-angle-up" />
                            </span>
                        {/if}
                    </div> -->
    </div>
    {#if openDropdown && userDetails}
        <div class="block">
            <div class="columns is-multiline">
                <div class="column is-6">
                    <div class="box">
                        <!-- <p class="is-size-5">Gruppen</p>
                                <p class="is-size-6">
                                    {userDetails.groups.join(", ")}
                                </p> -->
                    </div>
                </div>
                <div class="column is-6">
                    <div class="box">
                        <p class="is-size-5">Rollen</p>
                        <!-- <p class="is-size-6">
                                    {userDetails.roles.join(", ")}
                                </p> -->
                    </div>
                </div>
                <div class="column is-12">
                    <div class="box">
                        <!-- <PermissionsTable
                                    permissions={userDetails.permissions}
                                    editable={false}
                                    changePermissionsHandler={() => null}
                                /> -->
                    </div>
                </div>
            </div>
        </div>
    {/if}
</div>

<style>
    .card {
        margin: 5px 0;
    }

    .image,
    .icon {
        cursor: pointer;
    }
    .column {
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
    }

    .box {
        height: 100%;
    }

    .username {
        color: darkblue;
    }

    /* unvisited link */
    .username:link {
        color: darkblue;
    }

    /* visited link */
    .username:visited {
        color: darkblue;
    }

    /* mouse over link */
    .username:hover {
        color: darkblue;
        cursor: pointer;
    }

    /* selected link */
    .username:active {
        color: darkblue;
    }
</style>
